<template>
    <div>
      <div class="content f_mento">
        <div class="mento" v-for="member in memberData" :key="`member${member.m_idx}`" style="display: inline-block">
          <div class="m_image" :style="`background-image : url(${returnProfile(member)})`"></div>
          <div class="m_name"> {{member.m_name}}</div>
          <div class="m_job"> {{member.m_job}}</div>
          <div class="m_memo" v-html="member.m_memo"> </div>
        </div>
        <!--
        <div class="mento">
          <div class="m_image"></div>
          <div class="m_name"> 김혜준</div>
          <div class="m_job"> 사회운동가</div>
          <div class="m_memo"> 심하게 다이어트를 한 호빵맨입니다. 사단법인 함꼐하는 아버지들의 대표로 일하고 있습니다^^</div>
        </div>-->
          <div v-if="memberData.length === 0">
              데이터가 없습니다.
          </div>
      </div>
    </div>

</template>

<script>
    import util from "@/mixins/util";
    import imageOption from "@/mixins/imageOption";
    export default {
        name: "MemberListDefaultLayout",
        mixins: [imageOption],
        components: {},
        props: {
            memberData: {
                type: Array,
                default: () => {
                    return []
                }
            },
        },
        data() {
            return {}
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            returnProfile(member){
                return !util.isEmpty(member.profile)? `${member.profile[0].org_url}?${this.setImageOptions(128,128,'jpg')}` : ''
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>